import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apiClient } from '@/api';
import { ROUTE_DEFINITIONS } from '@/routes';
import { useAppDispatch } from '@/hooks';
import { logout } from '@/store/slices/authSlice';
import { addNotification } from '@/store/slices/uiSlice';
import { getRexSSOLoginUrl } from '@/api/core/apiConfig';

/**
 * Hook para configurar el manejo de errores de autenticación global.
 * Debe ser usado una sola vez en el componente raíz de la aplicación.
 */
export const useAuthErrorHandler = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t: translate } = useTranslation();

  useEffect(() => {
    apiClient.setUnauthorizedHandler((errorCode?: string) => {
      dispatch(logout());
      if (errorCode === 'SSO_SESSION_INVALIDATED') {
        window.location.href = getRexSSOLoginUrl();
        return;
      }
      void navigate(ROUTE_DEFINITIONS.INICIAR_SESION.path, { replace: true });
    });

    apiClient.setForbiddenHandler(() => {
      dispatch(addNotification({
        type: 'error',
        message: translate('common:permissions.denied'),
        duration: 5000,
      }));
    });

    // Cleanup: remover los handlers al desmontar
    return () => {
      apiClient.setUnauthorizedHandler(() => {});
      apiClient.setForbiddenHandler(() => {});
    };
  }, [navigate, dispatch, translate]);
};
